import React from "react";
import AuthService from "../services/auth.service";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Admin = () => {
  const { t } = useTranslation();
  const currentUser = AuthService.getCurrentUser();
  const isAdmin =
    currentUser && (currentUser.roles || []).includes("ROLE_ADMIN");
  const links = [
    { to: "/create-catalog", title: t("admin.catalogTitle"), desc: t("admin.catalogDesc") },
    { to: "/create-sub-catalog", title: t("admin.subCatalogTitle"), desc: t("admin.subCatalogDesc") },
    { to: "/products", title: t("admin.productsTitle"), desc: t("admin.productsDesc") },
    { to: "/manage-orders", title: t("admin.ordersTitle"), desc: t("admin.ordersDesc") },
    { to: "/manage-news", title: t("admin.newsTitle"), desc: t("admin.newsDesc") },
    { to: "/manage-albums", title: t("admin.albumsTitle"), desc: t("admin.albumsDesc") },
    { to: "/upload", title: t("admin.uploadTitle"), desc: t("admin.uploadDesc") },
    // Account management is admin-only.
    ...(isAdmin
      ? [{ to: "/manage-users", title: t("admin.usersTitle"), desc: t("admin.usersDesc") }]
      : []),
  ];
  return (
    <div className="container mt-4">
      <h3 className="mb-3">{t("admin.title")}</h3>
      <p className="text-muted">{t("admin.subtitle")}</p>

      <div className="row">
        {links.map((l) => (
          <div className="col-12 col-sm-6 col-lg-3 mb-4" key={l.to}>
            <Link to={l.to} className="text-decoration-none text-reset">
              <div className="card h-100 product-card">
                <div className="card-body">
                  <h5 className="card-title">{l.title}</h5>
                  <p className="card-text small text-muted">{l.desc}</p>
                </div>
              </div>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Admin;
